import { NavLink } from 'react-router-dom';

const navItems = [
  { path: '/', icon: 'ri-dashboard-3-line', label: 'Dash' },
  { path: '/produtos', icon: 'ri-shirt-line', label: 'Produtos' },
  { path: '/vendas', icon: 'ri-shopping-bag-3-line', label: 'Vendas' },
  { path: '/despesas', icon: 'ri-bill-line', label: 'Despesas' },
  { path: '/aportes', icon: 'ri-arrow-down-circle-line', label: 'Aportes' },
  { path: '/retiradas', icon: 'ri-arrow-up-circle-line', label: 'Retiradas' },
  { path: '/retirada-produtos', icon: 'ri-gift-line', label: 'Ret.Prod' },
];

export default function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-dark-card border-t border-dark-border md:hidden">
      <div className="flex items-center justify-around px-1 py-1">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 px-2 py-2 rounded-lg transition-all cursor-pointer min-w-0 flex-1
              ${isActive ? 'text-neon' : 'text-dark-muted'}`
            }
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className={`${item.icon} text-lg`}></i>
            </div>
            <span className="text-[9px] font-medium leading-none">{item.label}</span>
          </NavLink>
        ))}

      </div>
    </nav>
  );
}
